import React, { useState } from 'react';
import { ReactComponent as ArrowDown } from 'src/Images/icons/common/arrowdown.svg';
import 'src/style/vehicletrackingqualitycheck.css';
import 'src/style/targetvsactual.css';
import getColorCode from 'src/utils/GetThemeColor';
import QualityCheckLog from 'src/components/VehicleTrackingDetails/QualityCheck/QualityCheckLog';
import CircularChart from 'src/utils/CircularChart';
import { useSelector } from 'react-redux';

export default function QualityCheckLogs({
  qualityCheck,
  isSelected,
  onSelectionChange,
}) {
  const [showTable, setShowTable] = useState(false);

  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer.userData.tenant?.theme;

  // Handle checkbox change
  const handleCheckboxChange = () => {
    onSelectionChange(qualityCheck.quality_check_id);
  };
  // Transform logs data to component format
  const rows =
    qualityCheck.logs?.map((log) => ({
      logId: log.log_id,
      products: log.products?.map((product) => product.name) || [],
      dateLabel: log.created_timestamp,
      status: log?.status,
    })) || [];

  const totalLogs = qualityCheck.logs?.length || 0;

  const approvedCount =
    qualityCheck.logs?.filter((log) => log.status?.name === 'Approved')
      ?.length || 0;

  return (
    <div
      className={`quality-check-logs-table expand-on-hover-wrapper  ${showTable ? 'expanded' : ''}`}
    >
      <div className="pill-start">
        <div className="d-flex border-bottom">
          <div className="d-flex flex-grow-1 justify-content-between align-items-center quality-check-logs-header">
            <div className="text-md">
              <div className="div-flex-row cg-10 div-align-center">
                <input
                  type="checkbox"
                  className="checkbox-grey"
                  checked={isSelected}
                  onChange={handleCheckboxChange}
                />
                <span>{qualityCheck.quality_check_name}</span>
              </div>
            </div>
            <div className="div-flex-row cg-10">
              <button
                className="view-quality-check-log-button div-flex-row cg-5 div-align-center"
                onClick={() => setShowTable(!showTable)}
                aria-label="Toggle activity log"
              >
                <span className="text-blue text-sm text-semi-bold">
                  {showTable ? 'View less' : 'View more'}
                </span>
                <ArrowDown
                  className={`icon-size-md ${showTable ? 'rotate-icon-180' : ''} text-blue`}
                  color={getColorCode(themeColor)}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="expand-on-hover-content">
        <div className="d-flex justify-content-between align-items-center quality-check-logs-sub-header border-top">
          <span className="text-sm text-grey">
            Total number of quality check logs
          </span>
          <div className="div-flex-row div-align-center cg-5">
            <span className="text-md text-grey">{approvedCount}</span>
            <span className="text-md text-grey">/ {totalLogs}</span>
            <CircularChart
              value={(approvedCount / totalLogs) * 100 || 0}
              circumferenceColor="#0E9A26"
            />
          </div>
        </div>
        <div className={`theme-horizontal-scrollable-container-${themeColor}`}>
          {rows.map((r) => (
            <QualityCheckLog
              key={`${qualityCheck.quality_check_id}-${r.logId}`}
              themeColor={themeColor}
              products={r.products}
              dateLabel={r.dateLabel}
              status={r.status}
              qualityChecklogId={r.logId}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
